import type { ReactNode } from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { useRegionalFormat } from "@/lib/regional-format/context";

/**
 * Wraps a relative-time text ("3 days ago") and reveals the absolute date
 * and time, in the tenant's regional format, on hover. `date` is a `Date`
 * (or null for an unparseable value) rather than a raw string — a stored DB
 * string would otherwise be parsed host-local by `formatDateTime` (QL-691).
 */
export function TimeAgoTooltip({ date, children }: { date: Date | null; children: ReactNode }) {
  const { formatDateTime } = useRegionalFormat();
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span>{children}</span>
      </TooltipTrigger>
      <TooltipContent>{formatDateTime(date)}</TooltipContent>
    </Tooltip>
  );
}
